import { Card, CardContent } from "@mui/material";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "../powerbi.css";

export const GeographicAnalysisList = () => {
  return (
    <Card sx={{ margin: 2, height: "100%" }}>
      <CardContent
        sx={{
          height: "100%",
          padding: 0,
          "&:last-child": { paddingBottom: 0 },
        }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          <PowerBIEmbed
            embedConfig={{
              type: "report",
              embedUrl:
                "https://app.powerbi.com/view?r=eyJrIjoiZmJiNWI5N2QtNzliNS00NmI0LWE5NTUtODc0OTRkMjk4ZjIxIiwidCI6IjFkYjBkZmU3LWNlNTAtNDZjZC05YmMwLWIzNjY3YzdmMjExZiJ9&chromeless=1&navContentPaneEnabled=false",
              accessToken: "",
              tokenType: models.TokenType.Embed,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                },
                bars: {
                  actionBar: {
                    visible: false,
                  },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Geographic Analysis report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Geographic Analysis report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log("Geographic Analysis error:", event?.detail);
                  },
                ],
              ])
            }
            cssClassName="powerbi-report-container"
          />
        </div>
      </CardContent>
    </Card>
  );
};
